export const DOCUMENT_CATEGORIES = [
  "Resume",
  "Cover Letter",
  "Transcript",
  "Certification",
  "Portfolio",
  "Writing Sample",
  "Offer Letter",
  "Recommendation",
  "Other",
  "Job post",
  "Follow Up after application",
  "Interview Prep Questions",
  "Questions to Ask",
  "Follow Up after Interview",
  "Thank You after Interview",
  "Reschedule Interview",
  "Decline Interview",
  "Offer Negotiation",
  "Offer Acceptance",
  "Offer Decline",
  "Offer Time Extensions Request",
  "LinkedIn Profile Summary",
  "LinkedIn New Job Announcement",
  "LinkedIn Job Search Announcement",
  "Networking Message",
] as const;

